import React, { useContext } from "react";
import { Link } from 'react-router-dom';
import { AppContext } from "../App";
import { getBlogExcerpt, getImageUrl, getSafeDateLabel } from "../pages/homepageUtils";

export default function HomepageBlog({ d }) {
  const strapiURL = useContext(AppContext);

  if (!d) {
    return null;
  }

  const imageUrl = getImageUrl(d, strapiURL);
  const excerpt = getBlogExcerpt(d.Body);

  return (
    <Link to={`/blog/${d.documentId}`} className="retro-archive-row">
      <div className="retro-archive-date">{getSafeDateLabel(d.Date)}</div>
      <div className="retro-archive-body">
        <h3>{d.Title}</h3>
        {excerpt && <p>{excerpt}</p>}
      </div>
      <div className="retro-archive-thumb">
        {imageUrl ? (
          <img loading="lazy" decoding="async" src={imageUrl} alt={d.Title} />
        ) : (
          <span>LOG</span>
        )}
      </div>
    </Link>
  );
}


